<style lang="scss">
  @import '../resources/scss/project_header_details.scss';
</style>

<script lang="ts">
  import type Projects from '../api/rest/directus-cms/projects/model/Projects'

  export let p: Projects
</script>

<h1 class="text-white mb-0">{p.translations[0]?.name}</h1>
<div class="row text-white description">
  <div class="col-12">
    {@html p.translations[0]?.description}
  </div>
</div>
